module.exports = __webpack_public_path__ + "img/Group 9165.da15e63f.png";